import React, { useEffect } from 'react'
import Heading from '@react/react-spectrum/Heading'
import { Image } from '@react/react-spectrum/Image'
import imgExploreApis from '../../asset/home/explore.png'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import { setBodyHeight } from '../../lib/easybake'

export default function Home () {
    useEffect(() => {
        setBodyHeight()
        console.log(process.env.REACT_APP_CONFIG_APP_ENV)
    }, [])
    return (
        <div className="adobe-easybake-main-pane">
            <div className="adobe-easybake-main adobe-easybake-home">
                <div className="adobe-easybake-home-content">
                    <Image className="adobe-easybake-main-img" src={imgExploreApis} alt="Explore APIs"/>
                    <Heading variant="pageTitle">{__('home_title')}</Heading>
                    <p>{__('home_desc')}</p>
                </div>
            </div>
        </div>
    )
}
